import * as React from "react";
import classnames from "classnames";
/* empty css                        */
const HighlightedContent = ({ children, className }) => {
  if (!children) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", { className: classnames("highlighted-content", className), "data-t": "highlighted-content" }, /* @__PURE__ */ React.createElement("div", { className: "highlighted-content__inner" }, /* @__PURE__ */ React.createElement("article", { className: "highlighted-content__items" }, children)));
};
export {
  HighlightedContent as default
};
//# sourceMappingURL=HighlightedContent.js.map
